import { NavLink } from 'react-router-dom';
import {
  Activity,
  BarChart3,
  Boxes,
  Building2,
  Flame,
  History,
  Home,
  Linkedin,
  ClipboardCheck,
  MessagesSquare,
  Presentation,
  Rocket,
  Sparkles,
  Star,
  Sun,
  TrendingUp,
  Utensils,
  Zap,
} from 'lucide-react';
import { cn } from '@/lib/utils';

const NAV = [
  { to: '/', label: 'Today', icon: Sun, exact: true },
  { to: '/studio', label: 'Studio', icon: Sparkles },
  { to: '/overview', label: 'Overview', icon: Home },
  { to: '/review', label: 'Business Review', icon: Presentation },
  { to: '/outlets', label: 'Outlets', icon: Building2 },
  { to: '/sales', label: 'Sales', icon: BarChart3 },
  { to: '/journey', label: 'Target Journey', icon: Zap },
  { to: '/growth', label: 'Growth Journey', icon: TrendingUp },
  { to: '/aggregators', label: 'Aggregators', icon: TrendingUp },
  { to: '/aggregators-competitive', label: 'Aggregator competitors', icon: Boxes },
  { to: '/checklist', label: 'Checklist', icon: ClipboardCheck },
  { to: '/ratings', label: 'Ratings', icon: Star },
  { to: '/reviews', label: 'Reviews', icon: MessagesSquare },
  { to: '/ratings', label: 'Ratings', icon: Star },
  { to: '/meta', label: 'Meta', icon: Activity },
  { to: '/linkedin', label: 'LinkedIn', icon: Linkedin },
  { to: '/competitive', label: 'Competitive', icon: Boxes },
  { to: '/gap-reports', label: 'Gap reports', icon: History },
  { to: '/competitor-boosts', label: 'Boost signals', icon: Rocket },
  { to: '/influencers', label: 'Influencers', icon: Sparkles },
  { to: '/roi', label: 'ROI', icon: TrendingUp },
  { to: '/alerts', label: 'Alerts', icon: Flame },
];

export function Sidebar() {
  return (
    <aside className="hidden h-full w-56 shrink-0 border-r border-border/60 bg-card/40 px-3 py-4 md:flex md:flex-col">
      <div className="mb-4 flex items-center gap-2 px-2">
        <div className="flex h-8 w-8 items-center justify-center rounded-md bg-gradient-to-br from-violet-500 to-sky-500 text-white shadow-sm">
          <Utensils className="h-4 w-4" />
        </div>
        <div>
          <div className="text-sm font-semibold leading-tight">Flax</div>
          <div className="text-2xs text-muted-foreground">Marketing</div>
        </div>
      </div>
      <nav className="flex-1 space-y-0.5 overflow-y-auto">
        {NAV.map((item) => (
          <NavLink
            key={item.to + item.label}
            to={item.to}
            end={item.exact}
            className={({ isActive }) =>
              cn(
                'group flex items-center gap-2 rounded-md px-2 py-1.5 text-sm text-muted-foreground transition-colors hover:bg-accent hover:text-foreground',
                isActive && 'bg-accent text-foreground',
              )
            }
          >
            <item.icon className="h-4 w-4" />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
